<template>
  <app-layout :heading="$t('heading')">
    <v-progress-linear
      v-if="isLoading"
      :indeterminate="true"/>
    <template v-else>
      <v-alert
        :value="Boolean(formatStartedAt)"
        type="info">
        {{ $t('timerWasStartedAt', formatStartedAt) }}
      </v-alert>

      <v-layout
        column
        justify-center>
        <v-flex
          xs12
          md8
          class="my-5">
          <v-layout
            row
            wrap
            justify-center
            class="text-xs-center">
            <v-flex>
              <div class="display-3 font-weight-bold">{{ h }}</div>
              <div>hh</div>
            </v-flex>
            <v-flex>
              <div class="display-3 font-weight-bold">{{ m }}</div>
              <div>mm</div>
            </v-flex>
            <v-flex>
              <div class="display-3 font-weight-bold">{{ s }}</div>
              <div>ss</div>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex
          xs12
          md8
          class="text-xs-center">
          <v-btn
            v-if="!startedAt"
            grow
            large
            color="success"
            @click="start">{{ $t('start') }}
          </v-btn>
          <v-btn
            v-else
            grow
            large
            color="error"
            @click="stop">{{ $t('stop') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <v-flex>
      <h2 class="primary--text mt-5 mb-1">{{ $t('headingList') }}</h2>
    </v-flex>
    <v-layout>
      <v-flex xs12>
        <timetracking-table :track-list="closedTracks"/>
      </v-flex>
    </v-layout>
  </app-layout>
</template>

<script>
import AppLayout from '@/components/layouts/AppLayout.vue'
import timetrackingApi from '@/api/TimetrackingApi'
import timetrackingTable from './TimetrackingTable'

let counterInterval = null

export default {
  name: 'Timetracker',
  components: {
    AppLayout,
    timetrackingTable
  },
  data () {
    return {
      counter: 0,
      startedAt: null,
      isLoading: false,
      tracksOfToday: []
    }
  },

  computed: {
    formatStartedAt () {
      if (this.startedAt) {
        const dateTime = this.$moment(this.startedAt)
        return {
          date: dateTime.format('DD.MM.YYYY'),
          time: dateTime.format('HH:mm:ss')
        }
      }
    },
    durationOfClosedTracks () {
      return this.closedTracks.reduce((memo, curr) => {
        return memo + curr.durationInSeconds
      }, 0)
    },
    formattedTime () {
      return this.$moment()
        .hour(0)
        .minute(0)
        .second(this.counter)
    },
    h () {
      return this.formattedTime.format('HH')
    },
    m () {
      return this.formattedTime.format('mm')
    },
    s () {
      return this.formattedTime.format('ss')
    },
    closedTracks () {
      return this.tracksOfToday.filter(el => Boolean(el.active) === false)
    }
  },

  methods: {
    toMoment (date) {
      return this.$moment(date, 'YYYY-MM-DD HH:mm:ss')
    },
    async start () {
      this.startTimer(new Date())
      this.$notification(await timetrackingApi.start())
    },
    async stop () {
      this.$notification(await timetrackingApi.stop())
      clearInterval(counterInterval)
      this.startedAt = null
      this.initData()
    },
    startTimer (startTime) {
      this.startedAt = startTime
      const now = this.$moment()
      const start = this.$moment(startTime)
      const durationOfCurrentTrack = this.$moment.duration(now.diff(start)).asSeconds()
      this.counter = durationOfCurrentTrack + this.durationOfClosedTracks
      counterInterval = setInterval(() => this.counter++, 1000)
    },
    async initData () {
      this.tracksOfToday = await timetrackingApi.tracks()

      this.tracksOfToday
        .filter(el => !el.active)
        .forEach(el => {
          const $start = this.toMoment(el.start_time)
          const $end = this.toMoment(el.stop_time)
          el.durationInSeconds = this.$moment.duration($end.diff($start)).asSeconds()
        })
      this.counter = this.durationOfClosedTracks

      const openTrack = this.tracksOfToday.find(el => Boolean(el.active))
      if (openTrack) {
        const dateObj = this.$moment(openTrack.start_time, 'YYYY-MM-DD HH:mm:ss').toDate()
        this.startTimer(dateObj)
      }
    }
  },
  i18n: {
    messages: {
      en: {
        heading: 'Timetracking',
        headingList: 'Todays history',
        start: 'Start tracker',
        stop: 'Stop tracker',
        timerWasStartedAt: 'Tracker has been started on {date} at {time}.'
      },
      tr: {
        heading: 'Zaman takibi',
        headingList: 'Bugünün tarihi',
        start: 'Zaman takibini başlat',
        stop: 'Zaman takibini durdur',
        timerWasStartedAt: 'Zaman takibi {date} {time} tarihinde ve saatinde başlatıldı.'
      },
      de: {
        heading: 'Stundenzählung',
        headingList: 'Heutige Historie',
        start: 'Messung starten',
        stop: 'Messung stoppen',
        timerWasStartedAt: 'Messung wurde am {date} um {time} gestartet.'
      },
      ru: {
        heading: 'Отслеживание времени',
        headingList: 'Сегодняшняя история',
        start: 'Начать',
        stop: 'Остановить',
        timerWasStartedAt: 'Трекер был запущен в {date} в {time}.'
      }
    }
  },
  async created () {
    this.isLoading = true
    this.initData()
    this.isLoading = false
  }
}
</script>
